exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-pages-markdown-remark-fields-slug-jsx": () => import("./../../../src/pages/{markdownRemark.fields__slug}.jsx" /* webpackChunkName: "component---src-pages-markdown-remark-fields-slug-jsx" */)
}

